import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed } from "@preact/signals"
import { createLogger } from "@/utils/logger"

const logger = createLogger("")

const defaultUserWallet = {
    uid: "",
    balance: "0",
    withdrawable: "0",
}

async function fetchWallet() {
    await ApiSignalFetchers.fetchWalletSignal()
}

const wallet = computed(() => {
    return ApiSignals.walletSignal.value
})

const clearUserWallet = () => {
    ApiSignals.walletSignal.value = { ...defaultUserWallet }
}

const Wallet = {
    fetchWallet,
    wallet,
    clearUserWallet,
}

export default Wallet
